export const styles = {
  wrapper: {
    position: "relative",
    width: "100%",
    "max-height": "100vh",
    flex: "0 0 auto",
  },
  scrollContainer: {
    width: "100%",
    height: "100%",
    "overflow-x": "auto",
    "overflow-y": "auto",
    "scrollbar-width": "none",
    "scroll-snap-type": "x mandatory",
    "scroll-behavior": "smooth",
    "&::-webkit-scrollbar": { display: "none" },
  },
  snapTarget: {
    position: "absolute",
    top: "0",
    bottom: "0",
    width: "1px",
    "scroll-snap-align": "center",
    "pointer-events": "none",
  },
  track: {
    position: "relative",
    "min-width": "100%",
  },
  baseline: {
    position: "absolute",
    top: "var(--rail-pos)",
    right: "0",
    height: "2px",
    "background-color": "rgba(255, 255, 255, 0.25)",
  },
  yearTick: {
    position: "absolute",
    top: "calc(var(--rail-pos) - 5px)",
    width: "1px",
    height: "10px",
    "background-color": "rgba(255, 255, 255, 0.4)",
    "pointer-events": "none",
  },
  eventWrapper: {
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0",
    opacity: "0",
    transition: "opacity 400ms ease",
    "pointer-events": "none",
  },
  eventWrapperVisible: {
    opacity: "1",
  },
  card: {
    position: "absolute",
    width: "210px",
    "text-align": "center",
    display: "flex",
    "flex-direction": "column",
    gap: "6px",
    "align-items": "center",
    "@media (max-width: 600px)": {
      width: "200px",
    },
  },
  cardImage: {
    width: "190px",
    height: "auto",
    "border-radius": "8px",
    "flex-shrink": "0",
    "@media (max-width: 600px)": {
      width: "140px",
    },
  },
  cardPortrait: {
    width: "410px",
    "flex-direction": "row",
    "align-items": "center",
    "text-align": "left",
    gap: "14px",
    "@media (max-width: 600px)": {
      width: "340px",
      gap: "10px",
    },
  },
  cardImagePortrait: {
    width: "152px",
    "@media (max-width: 600px)": {
      width: "140px",
    },
  },
  cardBelowInteractive: {
    width: "420px",
    "flex-direction": "row",
    "align-items": "center",
    "text-align": "left",
    gap: "14px",
    transition: "width 350ms ease",
    "@media (hover: hover)": {
      "&:hover": {
        width: "660px",
      },
    },
    "@media (max-width: 600px)": {
      width: "350px",
      gap: "10px",
    },
  },
  cardSlideshow: {
    width: "440px",
    "flex-direction": "row",
    "align-items": "center",
    "text-align": "left",
    gap: "20px",
    "@media (max-width: 600px)": {
      width: "340px",
      gap: "14px",
    },
  },
  cardTextWrapper: {
    display: "flex",
    "flex-direction": "column",
    gap: "4px",
    "min-width": "0",
  },
  cardTitle: {
    margin: "0",
    color: "white",
    "font-size": "0.6em",
    "font-weight": "bold",
  },
  cardDescription: {
    margin: "0",
    color: "#bbb",
    "font-size": "0.5em",
    "line-height": "1.4",
    display: "-webkit-box",
    "-webkit-line-clamp": "3",
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
  },
  stem: {
    position: "absolute",
    width: "2px",
    "background-color": "#5E1219",
  },
  rail: {
    position: "absolute",
    height: "10px",
    "border-radius": "5px",
    "background-color": "#5E1219",
    "box-shadow": "0 0 0 4px #000000",
  },
  railOngoing: {
    position: "absolute",
    height: "10px",
    "border-radius": "5px 0 0 5px",
    "background-image":
      "linear-gradient(to right, #5E1219 0%, #5E1219 75%, rgba(94, 18, 25, 0) 100%)",
  },
  rangeBar: {
    position: "absolute",
    height: "10px",
    "border-radius": "5px",
    "background-color": "#5E1219",
    "box-shadow": "0 0 0 4px #000000",
  },
  rangeBarOngoing: {
    position: "absolute",
    height: "10px",
    "border-radius": "5px 0 0 5px",
    "background-image":
      "linear-gradient(to right, #5E1219 0%, #5E1219 75%, rgba(94, 18, 25, 0) 100%)",
  },
  dot: {
    position: "absolute",
    width: "14px",
    height: "14px",
    "border-radius": "50%",
    "background-color": "#5E1219",
    "box-shadow": "0 0 0 4px #000000",
  },
  junction: {
    position: "absolute",
    width: "10px",
    height: "10px",
    "border-radius": "50%",
    "background-color": "#5E1219",
    "box-shadow": "0 0 0 3px #000000",
  },
  year: {
    position: "absolute",
    color: "white",
    "font-size": "0.5em",
    "font-weight": "bold",
    "white-space": "nowrap",
  },
  arrow: {
    position: "absolute",
    top: "var(--rail-pos)",
    transform: "translateY(-50%)",
    "z-index": "2",
    opacity: "1",
    transition: "opacity 250ms ease",
    "@media (max-width: 600px)": {
      display: "none",
    },
  },
  arrowHidden: {
    opacity: "0",
    "pointer-events": "none",
  },
  arrowLeft: { left: "-8px" },
  arrowRight: { right: "-8px" },
  cardInteractive: {
    "pointer-events": "auto",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: "0",
    margin: "0",
    color: "inherit",
    font: "inherit",
    width: "100%",
    display: "flex",
    "flex-direction": "column",
    "align-items": "center",
    gap: "6px",
    "&:focus-visible": {
      outline: "2px solid white",
      "outline-offset": "4px",
      "border-radius": "4px",
    },
    "@media (hover: hover)": {
      "&:hover $cardImageInteractive": {
        width: "406px",
      },
      "&:hover $slideshowStackCardLeft": {
        transform: "rotate(-14deg) translate(-34px, 10px) scale(1.05)",
      },
      "&:hover $slideshowStackCardRight": {
        transform: "rotate(14deg) translate(34px, 10px) scale(1.05)",
      },
      "&:hover $slideshowStackCardCenter": {
        transform: "translateY(-6px) scale(1.08)",
      },
    },
  },
  cardImageInteractive: {
    transition: "width 300ms ease",
  },
  cardImageHidden: {
    opacity: 0,
  },
  cardInteractivePortrait: {
    "flex-direction": "row",
    "align-items": "center",
    "text-align": "left",
    gap: "10px",
  },
  cardInteractiveBelow: {
    "flex-direction": "row",
    "align-items": "center",
    "text-align": "left",
    gap: "14px",
  },
  cardInteractiveSlideshow: {
    "flex-direction": "row",
    "align-items": "center",
    "text-align": "left",
    gap: "20px",
  },
  modalBackdrop: {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    "background-color": "rgba(0, 0, 0, 0.8)",
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
    "z-index": "1000",
    padding: "24px",
    animation: "$modalBackdropFadeIn 300ms ease both",
  },
  modalBackdropExiting: {
    animation: "$modalBackdropFadeOut 800ms ease 300ms both",
  },
  "@keyframes modalBackdropFadeIn": {
    from: { "background-color": "rgba(0, 0, 0, 0)" },
    to: { "background-color": "rgba(0, 0, 0, 0.8)" },
  },
  "@keyframes modalBackdropFadeOut": {
    from: { "background-color": "rgba(0, 0, 0, 0.8)" },
    to: { "background-color": "rgba(0, 0, 0, 0)" },
  },
  modalContent: {
    position: "relative",
    "background-color": "#1a1a1a",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    "border-radius": "8px",
    "max-width": "800px",
    width: "100%",
    "max-height": "90vh",
    "overflow-y": "auto",
    padding: "32px",
    color: "white",
    "box-shadow": "0 20px 60px rgba(0, 0, 0, 0.5)",
    animation: "$modalChromeFadeIn 300ms ease 800ms both",
    "& > *:not(img):not($slideshow)": {
      animation: "$modalTextFadeIn 300ms ease 800ms both",
    },
    "@media (max-width: 600px)": {
      padding: "20px",
    },
  },
  modalContentExiting: {
    animation: "$modalChromeFadeOut 300ms ease both",
    "& > *:not(img):not($slideshow)": {
      animation: "$modalTextFadeOut 300ms ease both",
    },
    "& $slideshow > *:not($slideshowFrame)": {
      animation: "$modalTextFadeOut 300ms ease both",
    },
    "& $slideshowFrame": {
      animation: "$slideshowFrameBgOut 300ms ease both",
    },
    "& $slideshowNav": {
      animation: "$modalTextFadeOut 300ms ease both",
    },
  },
  "@keyframes modalChromeFadeIn": {
    from: {
      "background-color": "rgba(26, 26, 26, 0)",
      "border-color": "rgba(255, 255, 255, 0)",
      "box-shadow": "0 20px 60px rgba(0, 0, 0, 0)",
    },
    to: {
      "background-color": "rgba(26, 26, 26, 1)",
      "border-color": "rgba(255, 255, 255, 0.1)",
      "box-shadow": "0 20px 60px rgba(0, 0, 0, 0.5)",
    },
  },
  "@keyframes modalChromeFadeOut": {
    from: {
      "background-color": "rgba(26, 26, 26, 1)",
      "border-color": "rgba(255, 255, 255, 0.1)",
      "box-shadow": "0 20px 60px rgba(0, 0, 0, 0.5)",
    },
    to: {
      "background-color": "rgba(26, 26, 26, 0)",
      "border-color": "rgba(255, 255, 255, 0)",
      "box-shadow": "0 20px 60px rgba(0, 0, 0, 0)",
    },
  },
  "@keyframes modalTextFadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  "@keyframes modalTextFadeOut": {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
  modalClose: {
    position: "absolute",
    top: "12px",
    right: "12px",
    background: "none",
    border: "none",
    color: "white",
    "font-size": "24px",
    "line-height": "1",
    cursor: "pointer",
    padding: "8px",
    "border-radius": "4px",
    "&:hover": {
      "background-color": "rgba(255, 255, 255, 0.1)",
    },
    "&:focus-visible": {
      outline: "2px solid white",
      "outline-offset": "2px",
    },
  },
  modalImage: {
    width: "100%",
    "max-height": "50vh",
    "object-fit": "cover",
    "border-radius": "4px",
    "margin-bottom": "20px",
  },
  modalTitle: {
    margin: "0 0 8px 0",
    "font-size": "1.4em",
    "font-weight": "bold",
    "padding-right": "32px",
  },
  modalBody: {
    margin: "16px 0 0 0",
    color: "#ddd",
    "font-size": "0.95em",
    "line-height": "1.6",
    "white-space": "pre-wrap",
  },
  modalGallery: {
    display: "flex",
    "flex-wrap": "wrap",
    gap: "8px",
    "margin-top": "20px",
  },
  modalGalleryImage: {
    width: "calc(50% - 4px)",
    "max-height": "200px",
    "object-fit": "cover",
    "border-radius": "4px",
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  modalLinksSection: {
    "margin-top": "20px",
  },
  modalLinksTitle: {
    margin: "0 0 8px 0",
    color: "white",
    "font-size": "1em",
    "font-weight": "bold",
  },
  modalLinkWrapper: {
    display: "flex",
    "flex-wrap": "wrap",
    gap: "8px",
  },
  modalLink: {
    display: "inline-block",
    padding: "8px 16px",
    "background-color": "#5E1219",
    color: "white",
    "text-decoration": "none",
    "border-radius": "4px",
    "font-size": "0.9em",
    transition: "background-color 200ms ease",
    "&:hover": {
      "background-color": "#7a1822",
    },
    "&:focus-visible": {
      outline: "2px solid white",
      "outline-offset": "2px",
    },
  },
  slideshowStack: {
    position: "relative",
    width: "190px",
    height: "130px",
    "flex-shrink": "0",
    transform: "translateX(-8px)",
    transition: "transform 300ms ease",
    "@media (max-width: 600px)": {
      width: "140px",
      height: "96px",
    },
  },
  slideshowStackCard: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    "object-fit": "cover",
    "border-radius": "8px",
    border: "2px solid #1a1a1a",
    "box-shadow": "0 4px 12px rgba(0, 0, 0, 0.5)",
    transition: "transform 300ms ease",
    "backface-visibility": "hidden",
  },
  slideshowStackCardLeft: {
    transform: "rotate(-7deg) translate(-14px, 6px)",
    "z-index": "1",
  },
  slideshowStackCardCenter: {
    transform: "rotate(0deg)",
    "z-index": "3",
  },
  slideshowStackCardRight: {
    transform: "rotate(7deg) translate(14px, 6px)",
    "z-index": "2",
  },
  slideshow: {
    "margin-top": "20px",
    display: "flex",
    "flex-direction": "column",
    "align-items": "flex-start",
    gap: "10px",
    "& > *:not($slideshowFrame)": {
      animation: "$modalTextFadeIn 300ms ease 800ms both",
    },
  },
  slideshowFrame: {
    position: "relative",
    width: "100%",
    "border-radius": "6px",
    overflow: "hidden",
    "background-color": "rgba(0, 0, 0, 0)",
    animation: "$slideshowFrameBgIn 300ms ease 800ms both",
  },
  slideshowImage: {
    display: "block",
    width: "100%",
    "max-height": "50vh",
    "object-fit": "contain",
  },
  slideshowNav: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    "z-index": "2",
    width: "40px",
    height: "40px",
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
    "background-color": "rgba(0, 0, 0, 0.45)",
    color: "white",
    border: "none",
    "border-radius": "50%",
    cursor: "pointer",
    transition: "background-color 200ms ease",
    animation: "$modalTextFadeIn 300ms ease 800ms both",
    "&:hover": {
      "background-color": "rgba(94, 18, 25, 0.85)",
    },
  },
  "@keyframes slideshowFrameBgIn": {
    from: { "background-color": "rgba(0, 0, 0, 0)" },
    to: { "background-color": "rgba(0, 0, 0, 1)" },
  },
  "@keyframes slideshowFrameBgOut": {
    from: { "background-color": "rgba(0, 0, 0, 1)" },
    to: { "background-color": "rgba(0, 0, 0, 0)" },
  },
  slideshowNavLeft: { left: "8px" },
  slideshowNavRight: { right: "8px" },
  slideshowDots: {
    display: "flex",
    "flex-direction": "row",
    "justify-content": "center",
    gap: "8px",
    width: "100%",
    margin: "4px 0",
  },
  slideshowDot: {
    width: "10px",
    height: "10px",
    "border-radius": "50%",
    border: "none",
    padding: "0",
    "background-color": "rgba(255, 255, 255, 0.4)",
    cursor: "pointer",
    transition: "background-color 200ms ease, transform 200ms ease",
    "&:hover": {
      "background-color": "rgba(255, 255, 255, 0.7)",
    },
  },
  slideshowDotActive: {
    "background-color": "#5E1219",
    transform: "scale(1.25)",
  },
  slideshowTitle: {
    margin: "8px 0 0 0",
    color: "white",
    "font-size": "1.15em",
    "font-weight": "bold",
  },
  slideshowSubTitle: {
    margin: "0",
    color: "#bbb",
    "font-size": "0.9em",
    "font-weight": "normal",
    "font-style": "italic",
  },
  slideshowText: {
    margin: "8px 0 0 0",
    color: "#ddd",
    "font-size": "0.9em",
    "line-height": "1.5",
  },
};
